// extracted by mini-css-extract-plugin
module.exports = {"register-wrapper":"Register_register-wrapper__7xfj6","register":"Register_register__I5TyC","register-login":"Register_register-login__h7XZO"};